import { MutationHookOptions, useMutation } from '@apollo/client';

import { GET_INSURED_POLICIES } from './insured.submission.policies.query';
import { UpsertMidtermTransactionMutation } from '../gql/graphql';
import { graphql } from '../gql';

export function useUpsertMidtermTransaction(
  options: MutationHookOptions<UpsertMidtermTransactionMutation> = {}
) {
  const [upsertMidtermTransaction, { loading, error, reset, data }] =
    useMutation(
      graphql(`
        mutation upsertMidtermTransaction($input: MidtermTransactionInput!) {
          upsertMidtermTransaction(details: $input) {
            uuid
            type
            subType
            acquiringEntity
            effectiveDate
            mttPolicyExtensionDate
            endorsement {
              uuid
              name
              description
            }
            notes {
              edges {
                node {
                  uuid
                  note
                }
              }
            }
          }
        }
      `),
      {
        refetchQueries: [GET_INSURED_POLICIES],
        awaitRefetchQueries: true,
        ...options,
      }
    );

  return {
    upsertMidtermTransaction,
    loading,
    error,
    reset,
    data,
  };
}
